module.exports = __webpack_public_path__ + "img/h2.713d00a7.png";